import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const VideosTable = ({ openProgramModal, onEdit, onDelete, handlePageChange }) => {
  const { videos, currentVideoPage, totalVideoPages } = useSelector((state) => state.admin_videos);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredVideos, setFilteredVideos] = useState(videos);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (activeDropdown === id) {
      setActiveDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setActiveDropdown(id);
    }
  };

  useEffect(() => {
    const filtered = videos.filter(video =>
      video.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredVideos(filtered);
  }, [videos, searchTerm]);

  const handleDelete = (id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this video?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => onDelete(id)
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleScroll = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
    <div className="table-responsive">
        <table className="table table-striped table-users table-alex text-center printarea">
          <thead>
            <tr>
              <th><div className="text-start">Title</div></th>
              <th>Category</th>
              <th>Sort Order</th>
              <th>Video Url</th>
              <th style={{display:'none'}}>Type</th>
              <th className="noprint">Web Thumbnail</th>
              <th className="noprint">Mobile Thumbnail</th>
              <th className="noprint">Manage</th>
            </tr>
          </thead>
          <tbody>
            {
              filteredVideos.map((video) => (
                <tr key={video.id}>
                  <td><div className="text-start">{video.title}</div></td>
                  <td>{video.category_name}</td>
                  <td>{video.sort_order}</td>
                  <td >{video.video_url}</td>
                  <td style={{display:'none'}}>{video.video_type == 'url' ? 'URL' : 'Video File'}</td>
                  <td className="noprint">
                    <div className="text-start d-flex align-items-center img-placeholder me-2" style={{width:'150px', height:'150px'}} >
                      {video.web_thumbnail_full_url ? (
                        <img className="img-nutrition-meals me-2 entity_image" src={video.web_thumbnail_full_url} alt="Web Thumbnail" />
                      ) : (
                        <div className="img-placeholder me-2"><p>No Image</p></div>
                      )}
                    </div>
                  </td>
                  <td className="noprint">
                    <div className="text-start d-flex align-items-center img-placeholder me-2" style={{width:'150px', height:'150px'}}>
                      {video.mobile_thumbnail_full_url ? (
                        <img className="img-thumbnail" src={video.mobile_thumbnail_full_url} alt="Mobile Thumbnail" />
                      ) : (
                        <div className="img-placeholder me-2"><p>No Image</p></div>
                      )}
                    </div>
                  </td>
                  <td className="noprint">
                    <div className="text-center position-relative">
                      <button
                        type="button"
                        className="bg-transparent border-0 p-0 dropdown-toggle btn-vert-dots"
                        onClick={(e) => toggleDropdown(video.id, e)}
                      >
                        <img src={optionsIcon} alt="Options" />
                      </button>
                      {activeDropdown === video.id && (
                        <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  
                          <li>
                            <a className="dropdown-item" onClick={() => onEdit(video)}>
                              <img src={editIcon} alt="Edit" /> Edit
                            </a>
                          </li>

                           {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                          <li>
                            <a className="dropdown-item" onClick={() => handleDelete(video.id)}>
                              <img src={deleteIcon} alt="Delete" /> Delete
                            </a>
                          </li>
                          )}
                          
                        </ul>
                      )}
                    </div>
                  </td>
                </tr>
             
            ))}
          </tbody>
        </table>
      </div>
      <Pagination 
        currentPage={currentVideoPage} 
        totalPages={totalVideoPages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default VideosTable;